import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=f56bfd00&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f56bfd00')) {
      api.createRecord('f56bfd00', component.options)
    } else {
      api.reload('f56bfd00', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=f56bfd00&", function () {
      api.rerender('f56bfd00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4pEkAqf7UlD84/JS/comp/openstreetmap.vue"
export default component.exports